import {
  REFUNDS,
  OLD_REFUNDS
} from './constants'

export function postRefund (data) {
  return axios.post(REFUNDS, data, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function postOldRefund (data) {
  return axios.post(OLD_REFUNDS, data, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      let reject
      if (error.response) {
        reject = new Error(error.response.data.error)
      } else {
        reject = new Error(error.message)
      }
      return Promise.reject(reject)
    })
}



// WEBPACK FOOTER //
// ./app/api/refunds.js